import { render, staticRenderFns } from "./SkipPageBlue.vue?vue&type=template&id=4e154815&scoped=true&"
import script from "./SkipPageBlue.vue?vue&type=script&lang=js&"
export * from "./SkipPageBlue.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.7@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e154815",
  null
  
)

export default component.exports